export type ReviewUserType = 'BUYER' | 'SELLER';

export const REVIEW_USER_TYPES = ['SELLER', 'BUYER'] as const;
